export default "__VITE_ASSET__nX_Prola__"